import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withModifiers as _withModifiers, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2cdb1c02"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_2 = { class: "row flex-wrap align-items-center gy-2 col-12" }
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
  /*#__PURE__*/_createElementVNode("button", {
    type: "submit",
    class: "btn btn-dark"
  }, " Reset Password ")
], -1))
const _hoisted_4 = { class: "col-auto" }
const _hoisted_5 = { class: "d-flex flex-column flex-wrap" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "row flex-wrap align-items-center gy-2 col-12" }, [
  /*#__PURE__*/_createElementVNode("div", { class: "col-auto" }, [
    /*#__PURE__*/_createElementVNode("button", {
      type: "submit",
      class: "btn btn-dark px-3 px-sm-4 py-2"
    }, " Reset Password ")
  ])
], -1))

import { ElMessage } from "element-plus";
import type { FormInstance, FormRules } from "element-plus";
import { reactive, ref, onMounted } from "vue";
import { ValidateFieldsError } from "async-validator";
import { useAuthStore } from "@/stores/auth";
import { useRoute, useRouter } from "vue-router";
import { handleInvalidForm } from "@/utilities/api";

type RequestFormData = { emailAddress: string };
type ResetFormData = {
  emailAddress: string;
  passwordResetToken: string;
  newPassword: string;
  confirmPassword: string;
};


export default /*#__PURE__*/_defineComponent({
  __name: 'ForgotPasswordForm',
  props: {
    code: {},
    email: {}
  },
  emits: ["done"],
  setup(__props: any, { emit: emits }) {

const props = __props;

const authStore = useAuthStore();


const router = useRouter();
const requestFormRef = ref<FormInstance>();
const resetFormRef = ref<FormInstance>();
let requestFormData = reactive<RequestFormData>({
  emailAddress: "",
});
let resetFormData = reactive<ResetFormData>({
  emailAddress: "",
  passwordResetToken: "",
  newPassword: "",
  confirmPassword: "",
});

const passwordRegex =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[^a-zA-Z0-9])(.{8,})$/;

const validatePassword = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please enter a password"));
  } else if (!passwordRegex.test(value)) {
    callback(
      new Error(
        "Minimum 8 characters: 1 uppercase, 1 lowercase, 1 symbol and 1 number"
      )
    );
  } else {
    if (resetFormData.confirmPassword !== "") {
      if (!resetFormRef.value) return;
      resetFormRef.value.validateField("confirmPassword", () => null);
    }
    callback();
  }
};

const validatePassword2 = (rule: any, value: any, callback: any) => {
  if (value === "") {
    callback(new Error("Please confirm the password"));
  } else if (value !== resetFormData.newPassword) {
    callback(new Error("The passwords do not match"));
  } else {
    callback();
  }
};

const requestRules = reactive<FormRules<RequestFormData>>({
  emailAddress: [
    {
      required: true,
      type: "email",
      message: "Please enter a valid email address",
      trigger: "change",
    },
  ],
});

const resetRules = reactive<FormRules<ResetFormData>>({
  emailAddress: [
    {
      required: true,
      type: "email",
      message: "Please enter a valid email address",
      trigger: "change",
    },
  ],
  newPassword: [
    { required: true, validator: validatePassword, trigger: "change" },
  ],
  confirmPassword: [
    { required: true, validator: validatePassword2, trigger: "change" },
  ],
});

onMounted(() => {
  if (props.code) {
    resetFormData.passwordResetToken = props.code;
  }

  if (props.email) {
    resetFormData.emailAddress = props.email;
    requestFormData.emailAddress = props.email;
  }
});

const submitForm = async (formEl: FormInstance | undefined) => {
  if (!formEl) return;
  await formEl.validate(async (valid, fields) => {
    if (valid) {
      console.log("valid");
      if (!props.code) {
        authStore.forgotPassword(requestFormData.emailAddress).then(() => {
          emits("done")
        })
      } else {
        miscStore.isLoading = false;
      }
    } else {
      handleInvalidForm(fields as ValidateFieldsError)
    }
  });
};

return (_ctx: any,_cache: any) => {
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_el_form = _resolveComponent("el-form")!

  return (!_ctx.code)
    ? (_openBlock(), _createBlock(_component_el_form, {
        key: 0,
        onSubmit: _cache[1] || (_cache[1] = _withModifiers(($event: any) => (submitForm(requestFormRef.value)), ["prevent"])),
        ref_key: "requestFormRef",
        ref: requestFormRef,
        class: "col-12 forgot-password-form",
        model: _unref(requestFormData),
        rules: requestRules,
        size: "large",
        "label-position": "top",
        "require-asterisk-position": "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_1, [
            _createVNode(_component_el_form_item, {
              class: "col-12 mb-4 mb-md-5",
              label: "Email",
              prop: "emailAddress"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  name: "emailAddress",
                  modelValue: _unref(requestFormData).emailAddress,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_unref(requestFormData).emailAddress) = $event)),
                  placeholder: "Enter your email (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _createElementVNode("div", _hoisted_2, [
            _hoisted_3,
            _createElementVNode("div", _hoisted_4, [
              _createVNode(_component_router_link, {
                class: "w-auto underline-hover",
                to: { name: 'Login' }
              }, {
                default: _withCtx(() => [
                  _createTextVNode("Return to login")
                ]),
                _: 1
              })
            ])
          ])
        ]),
        _: 1
      }, 8, ["model", "rules"]))
    : (_openBlock(), _createBlock(_component_el_form, {
        key: 1,
        onSubmit: _cache[5] || (_cache[5] = _withModifiers(($event: any) => (submitForm(resetFormRef.value)), ["prevent"])),
        ref_key: "resetFormRef",
        ref: resetFormRef,
        class: "col-12 forgot-password-form",
        model: _unref(resetFormData),
        rules: resetRules,
        size: "large",
        "label-position": "top",
        "require-asterisk-position": "right"
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_el_form_item, {
              class: "col-12 mb-3 mb-md-4",
              label: "Email",
              prop: "emailAddress"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  name: "emailAddress",
                  modelValue: _unref(resetFormData).emailAddress,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(resetFormData).emailAddress) = $event)),
                  placeholder: "Enter your email (*)"
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 mb-3 mb-md-4",
              label: "Password",
              prop: "newPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(resetFormData).newPassword,
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(resetFormData).newPassword) = $event)),
                  autocomplete: "off",
                  name: "newPassword",
                  type: "password",
                  placeholder: "Enter your password (*)",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            _createVNode(_component_el_form_item, {
              class: "col-12 mb-4 mb-md-5",
              label: "Confirm Password",
              prop: "confirmPassword"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_el_input, {
                  modelValue: _unref(resetFormData).confirmPassword,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(resetFormData).confirmPassword) = $event)),
                  autocomplete: "off",
                  name: "confirmPassword",
                  type: "password",
                  placeholder: "Confirm your password (*)",
                  "show-password": ""
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _hoisted_6
        ]),
        _: 1
      }, 8, ["model", "rules"]))
}
}

})